import { useMemo } from 'react';
import { usePageData } from '@/hooks/usePageData';
import { useTestMode } from '@/hooks/useTestMode';
import { type ILiveType } from '@/types/ILiveType';

export const useLiveType = () => {
  const { isTestMode } = useTestMode();
  const { domain } = usePageData();

  const liveType = useMemo<ILiveType>(() => {
    switch (true) {
      case domain === 'www.sport.pl' || isTestMode:
        return 'SPORT';
      default:
        return 'UNIVERSAL';
    }
  }, []);

  return {
    liveType,
  };
};
